<script>
  import { isEnglish } from "../stores/cookies.js";

  export let title = "";
  export let context = "";
  export let hourtext1 = "";
  export let hourtexttime1 = "";
  export let hourtext2 = "";
  export let hourtexttime2 = "";
  export let bsText = "";
  export let bsDateText1 = "";
  export let bsDateTextTime1 = "";
  export let bsDateText2 = "";
  export let bsDateTextTime2 = "";
  export let addressText = "";
  export let phoneNumber = null;
  export let phoneDisplay = "";
  export let mapsEmbedSrc = ""; // ← NEW: pass the full iframe src here, e.g. "https://www.google.com/maps/embed?pb=..."
</script>

<div
  class="relative block bg-blue-50 rounded-xl p-6 shadow-md max-w-md mx-auto
         transition-all duration-200 overflow-hidden"
>
  <!-- Title -->
  {#if title}
    <h2 class="text-center text-2xl md:text-3xl font-bold text-black mb-3">
      {title}
    </h2>
  {/if}

  <!-- Context -->
  {#if context}
    <h2 class="text-center text-1xl md:text-2xl font-bold text-black mb-3">
      {context}
    </h2>
  {/if}

  <!-- Hours -->
  <div class="mb-6 space-y-4">
    {#if hourtext1 || hourtexttime1}
      <div
        class="flex justify-between items-baseline gap-6 text-base md:text-lg text-gray-700"
      >
        <!-- Left side – normal text -->
        <span class="text-left flex-1">
          {hourtext1}
        </span>

        <!-- Right side – supports \n, keeps right alignment -->
        <span
          class="text-right font-medium whitespace-pre-line leading-relaxed"
        >
          {hourtexttime1}
        </span>
      </div>
    {/if}

    {#if hourtext2 || hourtexttime2}
      <div
        class="flex justify-between items-baseline gap-6 text-base md:text-lg text-gray-700"
      >
        <span class="text-left flex-1">
          {hourtext2}
        </span>

        <span
          class="text-right font-medium whitespace-pre-line leading-relaxed"
        >
          {hourtexttime2}
        </span>
      </div>
    {/if}
  </div>

  <!-- Bussiness -->
  {#if bsText}
    <h2 class="text-center text-1xl md:text-2xl font-bold text-black mb-3">
      {bsText}
    </h2>
  {/if}

  <!-- Hours -->
  <div class="mb-6 space-y-4">
    {#if bsDateText1 || bsDateTextTime1}
      <div
        class="flex justify-between items-baseline gap-6 text-base md:text-lg text-gray-700"
      >
        <!-- Left side – normal text -->
        <span class="text-left flex-1">
          {bsDateText1}
        </span>

        <!-- Right side – supports \n, keeps right alignment -->
        <span
          class="text-right font-medium whitespace-pre-line leading-relaxed"
        >
          {bsDateTextTime1}
        </span>
      </div>
    {/if}

    {#if bsDateText2 || bsDateTextTime2}
      <div
        class="flex justify-between items-baseline gap-6 text-base md:text-lg text-gray-700"
      >
        <span class="text-left flex-1">
          {bsDateText2}
        </span>

        <span
          class="text-right font-medium whitespace-pre-line leading-relaxed"
        >
          {bsDateTextTime2}
        </span>
      </div>
    {/if}
  </div>

  <!-- Address -->
  {#if addressText}
    <div class="flex items-start gap-3 mb-4">
      <div
        class="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center"
      >
        <svg
          class="w-5 h-5 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      </div>
      <p class="text-gray-800 text-base md:text-lg leading-relaxed">
        {addressText}
      </p>
    </div>
  {/if}

  <!-- Phone – highlights only on hover -->
  {#if phoneNumber}
    <div
      class="flex items-center gap-3 mb-5 cursor-pointer group/phone"
      on:click|preventDefault={() =>
        window.open(`tel:${phoneNumber.replace(/\s+/g, "")}`, "_self")}
      on:keydown={(e) =>
        e.key === "Enter" &&
        window.open(`tel:${phoneNumber.replace(/\s+/g, "")}`, "_self")}
      tabindex="0"
      role="button"
    >
      <div
        class="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center"
      >
        <svg
          class="w-5 h-5 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      </div>
      <p
        class="text-blue-600 font-semibold text-base md:text-lg transition-all duration-200
               group-hover/phone:text-blue-700 group-hover/phone:underline underline-offset-4
               decoration-transparent group-hover/phone:decoration-blue-700"
      >
        {phoneDisplay || phoneNumber}
      </p>
    </div>
  {/if}

  <!-- Google Maps interactive iframe – clickable, blue border on hover -->
  {#if mapsEmbedSrc}
    <div
      class="mt-5 rounded-lg overflow-hidden shadow-inner border-2 border-transparent hover:border-blue-500 transition-all duration-200"
    >
      <!-- svelte-ignore a11y-missing-attribute -->
      <iframe
        src={mapsEmbedSrc}
        class="w-full h-64 md:h-72 lg:h-80 border-0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  {/if}
</div>
